import React, {Component} from 'react'
import {FieldsManager} from '../../../../data/services/fields'
import Resources from '../../../../data/services/resources'
import {DEFAULT_METADATA_SELECT_SEARCH_QUERY} from '../../../../util/util-constants'
import {numberWithCommas, numberWithCommasToBack} from '../../../../util/util-formaters'
import {pushNotification} from '../../../../data/actions/ui'
import MagnifyingGlassIcon from "@heroicons/react/24/outline/MagnifyingGlassIcon";
import {TrashIcon} from "@heroicons/react/24/outline";
import PencilIcon from "@heroicons/react/24/outline/PencilIcon";
import ResourceTable from "../../../../common/components/resource-table";
import NoRecords from "../../../../common/components/no-records-found/no-records";
import ModalSaveResource from "../../../../common/components/modal/modal-save-resource";
import {getDefaultTableOptions} from "../../../../common/util/util-helpers";

export default class CreditMemoItemTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            //MODALS
            createModalOpen: false,
            editModalOpen: false,

            selectedItem: {},
            itemModalKey: 0,
            editItemModalKey: 10000,
            query: ''
        }

        this.itemsTableOptions = getDefaultTableOptions(this.getFields(), {
            style: {
                horizontalLines: true,
                verticalLines: true,
                condensed: true,
                isGPUAccelerated: true,
                condensedHeight: 38
            },
        }, 'credit-memo-item-table', this.props.translate);

        this.addDialogBtnRef = React.createRef();
    }

    /** UI Events
     ================================================================= */
    deleteResource = (item) => {
        this.props.onRemoveItem(item.index)
    }

    handleToggleCreateModal = () => {
        this.setState({
            createModalOpen: !this.state.createModalOpen
        })
    }

    handleToggleEditModal = (item = {}) => {
        this.setState({
            selectedItem: item,
            editModalOpen: !this.state.editModalOpen
        })
    }

    handleInputChange = (fields, name, value) => {
        fields = FieldsManager.updateField(fields, name, value)

        let updateTotal = false

        if (name === 'ProductServiceID') {
            fields = FieldsManager.updateField(fields, 'AccountID',
                value
                    ? {
                        label: value.metadata?.ExpenseAccount,
                        value: value.metadata?.ExpenseAccountID
                    }
                    : ""
            )
            fields = FieldsManager.updateField(fields, 'Description',
                value?.metadata?.ExpenseDescription ?? ""
            )
            fields = FieldsManager.updateField(fields, 'Amount',
                value?.metadata?.ExpensePrice ?? 0
            )
            updateTotal = true;

            if (fields?.ProductServiceTypeID?.value) {
                fields.ProductServiceTypeID.value = value?.metadata?.ProductServiceTypeID ?? "";
            }
        }

        if (name === 'Qty' || name === 'Amount' || updateTotal) {
            let total = (
                numberWithCommasToBack(fields.Qty.value)
                * numberWithCommasToBack(fields.Amount.value)
            );

            let totalCalculation = numberWithCommas(Math.round(total * 100) / 100) ? numberWithCommas(Math.round(total * 100) / 100) : 0

            fields = FieldsManager.updateField(fields, 'TotalAmount', totalCalculation)
        }

        if (name === 'Qty') {
                value = (!value ? "" : value.toString())
                    .replace(/[^0-9\-]/g, "");

                if (value.indexOf("-") > 0) {
                    value = value.replace(/-/g, "");
                }

                if (value.indexOf("-") === 0) {
                    value = `-${value.replace(/-/g, "")}`;
                }

                if (value === 0 || value === "0") {
                    value = ""
                }

            fields = FieldsManager.updateField(fields, 'Qty', value)
        }

        if (name === 'Total') {
            fields = FieldsManager.updateField(fields, 'Amount', value)
        }

        return fields
    }

    /** Fields/Data definitions
     ================================================================= */
    getFields = (item = {}) => {
        return this.props.getFields(item)
    }

    getFormattedFields = () => {
        return this.props.items.map((it, index) => {
            return Object.assign({}, FieldsManager.getFieldKeyValues(it),
                {
                    index: index,
                    ProductService: it.ProductServiceID?.value?.label ?? '',
                    Account: it.AccountID?.value?.label ?? '',
                })
        })
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, hideAddInlineItemButton, renderCells} = this.props
        const metadata = {
            ProductServiceID: {
                api: 'api/' + Resources.ProductsServices,
                query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
                searchMap: (item) => ({
                    label: item.ProductService,
                    value: item.ProductServiceID,
                    metadata: item
                })
            },
            AccountID: {
                api: 'api/' + Resources.AccountsQuick,
                query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
                searchMap: (item) => ({
                    value: item.AccountID,
                    label: item.AccountNumber + ' ' + item.AccountName
                })
            }
        }

        const data = this.getFormattedFields()


        const filteredData = data.filter(it => {
            const Amount = it?.Amount + ''
            const TotalAmount = it?.TotalAmount + ''
            let canPass = true
            if (this.state.query) {
                canPass &=
                    it.Description?.toLowerCase().includes(this.state.query?.toLowerCase())
                    ||
                    it.Account?.toLowerCase().includes(this.state.query?.toLowerCase())
                    ||
                    (parseFloat(Amount)?.toFixed(2).toString().toLowerCase().includes(this.state.query?.toLowerCase()))
                    ||
                    (parseFloat(TotalAmount)?.toFixed(2).toString().toLowerCase().includes(this.state.query?.toLowerCase()))
            }

            return canPass
        })


        return (
            <div className={this.props.className}>
                {!!data.length && (
                    <React.Fragment>
                        <div className="flex items-center justify-between px-4">
                            <p className="text-lg leading-6 font-medium text-tm-gray-900">Items</p>
                            <div className="relative mr-auto mx-4">
                                <div className="flex items-center">
                                    <MagnifyingGlassIcon className="absolute left-4 w-5 h-5 text-tm-gray-600"/>

                                    <input
                                        type="text"
                                        placeholder={translate("text.search")}
                                        className="form-control pl-10 rounded-t-card"
                                        value={this.state.query}
                                        autoFocus
                                        onChange={e => {
                                            this.setState({query: e.target.value})
                                        }}
                                    />
                                </div>

                            </div>

                            <button
                                onKeyDown={(event) => this.props.handleSelectFirstElement(event)}
                                onClick={this.handleToggleCreateModal}
                                disabled={this.props.isReadOnly}
                                className="btn btn-primary btn-xs">
                                {translate('btn.add_item')}
                            </button>
                        </div>

                        <div className="mt-6 bg-inverse">
                            <ResourceTable
                                tableKey={"index"}
                                maxHeightClass="max-h-[calc(100vh-30rem)]"
                                data={filteredData}
                                fields={this.getFields()}
                                options={this.itemsTableOptions}
                                renderCells={renderCells}
                                translate={translate}
                                actions={[
                                    {
                                        action: this.deleteResource,
                                        icon: TrashIcon,
                                        visible: (item) => this.props.items.length > 1 && !item.IsPayed && !this.props.isReadOnly,
                                        title: translate('btn.delete'),
                                        order: 20
                                    },
                                    {
                                        action: this.handleToggleEditModal,
                                        icon: PencilIcon,
                                        visible: (item) => !item.IsPayed && !this.props.isReadOnly,
                                        title: translate('btn.edit'),
                                        order: 10
                                    }
                                ]}
                            />
                        </div>

                        {!hideAddInlineItemButton && (
                            <div className="flex items-end justify-end">
                                <button ref={this.props.addBtnRef} className={"btn btn-outline mx-2 my-5"}
                                        disabled={this.props.isReadOnly}
                                        onClick={() => {
                                            this.props.onAddNewItem()
                                        }}>
                                    <span>Add and edit inline</span>
                                </button>
                            </div>
                        )}
                    </React.Fragment>
                )}

                {!data.length && (
                    <div className="py-4">
                        <NoRecords
                            canCreate={!this.props.isReadOnly}
                            show={true}
                            title={translate('text.no_items')}
                            text={translate('text.disabled_until_item_add')}
                            btnLabel={'Add new item'}
                            onBtnClick={this.handleToggleCreateModal}
                        />
                    </div>
                )}

                <ModalSaveResource
                    key={this.state.itemModalKey}
                    title={'Create new item'}
                    widthClass="max-w-md"
                    limitHeight={true}
                    gridColsClass="grid-cols-2"
                    show={this.state.createModalOpen}
                    onClose={this.handleToggleCreateModal}
                    fields={this.getFields()}
                    onSubmit={(params) => {
                        if (params) {
                            this.props.onAddNewItem(params)
                            this.handleToggleCreateModal()
                        }
                    }}
                    translate={this.props.translate}
                    metadata={metadata}
                    handleInputChange={this.handleInputChange}
                    getRawFields
                    secondaryButtonLabel={translate('btn.save_and_add_more')}
                    onSecondaryButtonClick={(params) => {
                        if (params) {
                            this.props.onAddNewItem(params)

                            this.setState({
                                itemModalKey: this.state.itemModalKey + 1
                            }, () => {
                                this.props.dispatch(pushNotification({
                                    title: this.props.translate('text.item_added'),
                                    timeout: true
                                }))
                            })
                        }
                    }}
                    disableSecondaryIfNotDirty={true}
                />

                <ModalSaveResource
                    key={this.state.editItemModalKey}
                    title={'Edit item'}
                    widthClass="max-w-md"
                    gridColsClass="grid-cols-1"
                    limitHeight={true}
                    show={this.state.editModalOpen}
                    onClose={this.handleToggleEditModal}
                    fields={this.getFields(this.state.selectedItem)}
                    onSubmit={(params) => {
                        if (params) {
                            if (this.state.selectedItem?.index > -1) {
                                this.props.onEditItem(params, this.state.selectedItem?.index)
                            } else {
                                this.props.onAddNewItem(params)
                            }
                            this.handleToggleEditModal()
                        }
                    }}
                    translate={this.props.translate}
                    metadata={metadata}
                    handleInputChange={this.handleInputChange}
                    getRawFields
                    secondaryButtonLabel={translate('btn.save_and_add_more')}
                    secondaryButtonDisabled={this.props.isReadOnly}
                    onSecondaryButtonClick={(params) => {
                        const selectedItemIndex = this.state.selectedItem?.index
                        if (params) {
                            if (selectedItemIndex > -1) {
                                this.props.onEditItem(params, selectedItemIndex)
                            } else {
                                this.props.onAddNewItem(params)
                            }

                            this.setState({
                                editItemModalKey: this.state.editItemModalKey + 1,
                                selectedItem: undefined
                            }, () => {
                                this.props.dispatch(pushNotification({
                                    title: this.props.translate('text.item_edited'),
                                    timeout: true
                                }))
                            })
                        }
                    }}
                    disableSecondaryIfNotDirty={true}
                />
            </div>
        )
    }
}